export default "__VITE_ASSET__db00182e__"